import Vue from "vue"
import Vuex from "vuex"
import ElementUI from "element-ui"
import VueRouter from "vue-router"
import App from "./modules/App.vue"
import VueECharts from "vue-echarts/components/ECharts"
import VueClipboard from 'vue-clipboard2'
import "element-ui/lib/theme-chalk/index.css"
import "echarts/lib/component/tooltip"
import "echarts/lib/component/legend"
import "echarts/lib/chart/bar"
import "echarts-gl"
import "element-ui/lib/theme-chalk/index.css"
import router from "./router"
import store from "./store"

Vue.use(Vuex)
Vue.component("chart", VueECharts)
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.use(VueRouter)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
